import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { jsPDF } from 'jspdf';
import { IoDownload } from 'react-icons/io5';
import './ExportBook.css';

export default function ExportBook({ book }) {
  const [exporting, setExporting] = useState(false);

  const handleExportPDF = () => {
    setExporting(true);

    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const margin = 20;
    const maxWidth = pageWidth - margin * 2;
    let y = 40;

    // Titre
    doc.setFontSize(24);
    doc.setFont('helvetica', 'bold');
    doc.text(book.title, pageWidth / 2, y, { align: 'center' });
    y += 10;

    // Auteur
    doc.setFontSize(14);
    doc.setFont('helvetica', 'normal');
    doc.text('par ' + book.author, pageWidth / 2, y, { align: 'center' });
    y += 20;

    // Note d'auteur
    if (book.authorNote) {
      doc.setFontSize(11);
      doc.setFont('helvetica', 'italic');
      const noteLines = doc.splitTextToSize(book.authorNote, maxWidth);
      doc.text(noteLines, margin, y);
      y += noteLines.length * 6 + 10;
    }

    // Chapitres
    book.chapters.forEach((chapter, i) => {
      if (y > 250) {
        doc.addPage();
        y = 20;
      }

      // Titre du chapitre
      doc.setFontSize(16);
      doc.setFont('helvetica', 'bold');
      y += 10;
      doc.text(chapter.title, margin, y);
      y += 10;

      // Contenu
      doc.setFontSize(11);
      doc.setFont('helvetica', 'normal');
      const cleanContent = chapter.content
        .replace(/\*\*(.*?)\*\*/g, '$1')
        .replace(/_(.*?)_/g, '$1')
        .replace(/^## /gm, '')
        .replace(/^> /gm, '')
        .replace(/^---$/gm, '———');

      const lines = doc.splitTextToSize(cleanContent, maxWidth);
      lines.forEach(line => {
        if (y > 275) {
          doc.addPage();
          y = 20;
        }
        doc.text(line, margin, y);
        y += 6;
      });

      y += 5;
    });

    // Footer
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(9);
      doc.setFont('helvetica', 'normal');
      doc.text('Plumly — ' + book.title, pageWidth / 2, 290, { align: 'center' });
      doc.text(i + ' / ' + pageCount, pageWidth - margin, 290, { align: 'right' });
    }

    doc.save(book.title.replace(/[^a-zA-Z0-9]/g, '_') + '.pdf');
    setExporting(false);
  };

  if (!book.chapters || book.chapters.length === 0) return null;

  return (
    <motion.button
      className="export-btn"
      onClick={handleExportPDF}
      disabled={exporting}
      whileTap={{ scale: 0.95 }}
    >
      <IoDownload /> {exporting ? 'Export...' : 'PDF'}
    </motion.button>
  );
}